/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Out_Reason_DiscardInputs */

const vi_pl_out_reason_discard = /** @type {(inputs: Pl_Out_Reason_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại bỏ`)
};

/**

* @param {Pl_Out_Reason_DiscardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_out_reason_discard = /** @type {((inputs?: Pl_Out_Reason_DiscardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Out_Reason_DiscardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_out_reason_discard(inputs)
});